import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { SERVER_URL } from '../../constants/url';


// 설문지 소개 페이지

const ContentWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: var(--sp-32);
`;


const QuestionTitle = styled.p`
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: var(--sp-10) var(--sp-16);
    font-size: var(--mo-fz-md);
    font-weight: var(--fz-weight-700);
    color: var(--color-main-gray);
    white-space: pre-wrap;
    text-align: center;
`;


const ImgBoxCont = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    // max-width: 75%;
    margin-top: var(--sp-20);
    padding: 0 var(--sp-16);
        & div {
            overflow: hidden;
            width: 100%;
            border-radius: var(--radius-12);
            & img {
                display: block;
                width: 100%; 
                object-fit: contain;
            }
        }
`;



const SubjectInputBox = styled.div`
    width: 100%;
    height: 12.8rem;
    margin-top: var(--sp-20);
    padding: 0 var(--sp-16);
    border-radius: var(--radius-12);
    
    & textarea {
        resize: none;
        width: 100%;
        height: 100%;
        padding: var(--sp-12) var(--sp-16);
        border: 2px solid var(--color-main-bg-gray-40);
        border-radius: var(--radius-12);
        font-size: var(--mo-fz-md);
        font-weight: var(--fz-weight-700);
        color: var(--color-main-black);
        outline: none;
        transition: all 0.2s ease;

        &:focus {
            border-color: var(--color-main-5);
        }   
        &::placeholder {

            font-weight: var(--fz-weight-500);
            color: var(--color-main-gray-50);
        }
        &::-webkit-scrollbar {width: 20px; height: 3px;} 
        &::-webkit-scrollbar-track {background: transparent; border-radius: var(--radius-12);}
        &::-webkit-scrollbar-thumb {background: #E2E6EC; border-radius: var(--radius-12);  border: 7px solid #fff;}
    }
    
`;

const Boundary = styled.div`
    display: flex; 
    align-items: center; 
    justify-content: center; 
    position: relative;
    width: 100%;
    height: var(--sp-28);
    margin-top: var(--sp-32);
    margin-bottom: var(--sp-14);
    border-top: 1px solid var(--color-main-15);
    background-color: var(--color-main-25);

    &:before {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%; 
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 8px solid var(--color-main-25);
    }
    
    & span {
        font-size: var(--mo-fz-sm);
        color: var(--color-main-65);
        font-weight: var(--fz-weight-700);
    } 
`;

const CountText = styled.div`
    width: 100%;
    padding-right: var(--sp-16);
    margin-top: var(--sp-10);
    text-align: right;
    font-size: var(--mo-fz-smd);
    color: var(--color-main-gray);
`;


const CostomSurveySubject = ({surveyData, selectedValue, onChange, step }) => {

    const { qesitmNo, qesitmCn, qestAtchFileStr, qestAtchFileStrSub } = surveyData;

    // selectedValue?.value가 문자열이 아닐 수 있으므로 안전하게 처리
    const text = typeof selectedValue?.value === 'string' ? selectedValue.value :
                 typeof selectedValue === 'string' ? selectedValue : '';


    //no-imgage 관련
    const [imgError, setImgError] = useState(false);

    const handleTextChange = (e) => {
    const value = e.target.value.slice(0, 500);

    onChange(null, value);
  };

    const BoldText = ({ text }) => {
            // text가 문자열이 아니면 빈 문자열로 처리
            if (!text || typeof text !== 'string') {
                return null;
            }
            const parts = text.split(/(\*[^*]+\*|\[[^\]]+\])/g);

            return (
                <>
                    {parts.map((part, idx) => {
                        if (part.startsWith('*') && part.endsWith('*')) {
                            const boldText = part.slice(1, -1);
                            return <strong key={idx}>{boldText}</strong>;
                        }
                        if (part.startsWith('[') && part.endsWith(']')) {
                            const colorText = part;
                            return <span key={idx} style={{ color: '#E55151' }}>{colorText}</span>;
                        }

                        return part.split('\n').map((line, i) => (
                            <React.Fragment key={`${idx}-${i}`}>
                                {line}
                                {i < part.split('\n').length -1 && <br />}
                            </React.Fragment>
                        ));
                    })}
                </>
            );
    };

    // 노이미지 핸들러
    const handleMainImageError = () => {
        setImgError(true);
    };

    return (

        <ContentWrap>

            {/* 질문 내용 */}
            <QuestionTitle>
                <BoldText text={qesitmCn} />
            </QuestionTitle>

            { qestAtchFileStrSub !== undefined && (
                <ImgBoxCont className='imgbox'>
                    <div>
                        {imgError ? (
                                <img
                                    src={`/images/common/no_img.png`}
                                    alt={`no-img`}
                                />
                            ) : (
                                <img
                                    src={`${SERVER_URL}/cmm/fms/getImage?atchFileStr=${qestAtchFileStr}&fileSn=${qestAtchFileStrSub}`}
                                    alt={qesitmCn}
                                    onError={handleMainImageError}
                                />
                            )
                        }
                    </div>

                </ImgBoxCont>
            )}

            <Boundary>
                <span>답변 선택</span>
            </Boundary>


            {/* 주관식 입력 */}

            <SubjectInputBox>
                <textarea
                    value={text}
                    placeholder='내용을 입력해주세요.'
                    name={qesitmNo}
                    maxLength={500}
                    onChange={handleTextChange}
                >


                </textarea>
            </SubjectInputBox>

            <CountText>
                {text.length} / 500
            </CountText>



        </ContentWrap>

    );
};

export default CostomSurveySubject;
